module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Thumbtack-30b10502796dd5b4725c0d479db494a3.svg";